import React from "react";
import { ScheduleView } from "@components";

const FacilitiesPage: React.FC = () => {
  return (
    <ScheduleView contentDisplayed="facilities" />
  );
};

export default FacilitiesPage;